import { render, staticRenderFns } from "./onlyMall.vue?vue&type=template&id=673c1c78&scoped=true&"
import script from "./onlyMall.vue?vue&type=script&lang=ts&"
export * from "./onlyMall.vue?vue&type=script&lang=ts&"
import style0 from "./onlyMall.vue?vue&type=style&index=0&id=673c1c78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c1c78",
  null
  
)

export default component.exports